module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('error-page', {
    attrs: {
      "code": "404",
      "description": _vm.description
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3d9d7ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/404.vue
// module id = 2658
// module chunks = 0